import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    // No stacking context here on purpose: `relative z-0` would trap in-page
    // modals below every body-portalled Radix layer. Layering is governed by
    // the z-index tokens in tailwind.config.cjs instead.
    <div className="flex h-[100dvh] overflow-hidden bg-background">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto p-3 sm:p-4 md:p-5">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
